(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-verification"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const AGE_VERIFIED_KEY = 'age_verified';
    const AGE_VERIFICATION_STORAGE_KEY = 'age_verification_status';
    
    const ageVerification = document.getElementById('age-verification');
    const yesButton = document.getElementById('age-verify-yes');
    const noButton = document.getElementById('age-verify-no');
    const deniedMessage = document.getElementById('age-verification-denied');
    
    if (!ageVerification || !yesButton || !noButton) {
      console.error('Age verification elements not found');
      return;
    }
    
    // Check if user has already verified their age in this session
    const ageVerified = sessionStorage.getItem(AGE_VERIFIED_KEY);
    
    // Show popup if not verified in this session
    if (!ageVerified) {
      ageVerification.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    } else if (ageVerified === 'denied') {
      // User was denied, show denied message
      ageVerification.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      yesButton.style.display = 'none';
      noButton.style.display = 'none';
      if (deniedMessage) {
        deniedMessage.style.display = 'block';
      }
    } else {
      // User already verified, hide popup
      ageVerification.style.display = 'none';
    }
    
    // Handle "Yes" button click
    yesButton.addEventListener('click', function() {
      // Store verification in sessionStorage (clears on browser close)
      sessionStorage.setItem(AGE_VERIFIED_KEY, 'true');
      // Also store in localStorage for persistence across sessions
      localStorage.setItem(AGE_VERIFICATION_STORAGE_KEY, 'verified');
      
      // Dispatch custom event for email popup
      window.dispatchEvent(new CustomEvent('ageVerified'));
      
      // Hide popup with fade out
      ageVerification.style.opacity = '0';
      ageVerification.style.transition = 'opacity 0.3s ease';
      
      setTimeout(function() {
        ageVerification.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    });
    
    // Handle "No" button click
    noButton.addEventListener('click', function() {
      // Hide buttons
      yesButton.style.display = 'none';
      noButton.style.display = 'none';
      
      // Show denied message
      if (deniedMessage) {
        deniedMessage.style.display = 'block';
      }
      
      // Store denial in sessionStorage
      sessionStorage.setItem(AGE_VERIFIED_KEY, 'denied');
      localStorage.setItem(AGE_VERIFICATION_STORAGE_KEY, 'denied');
      
      // Prevent access - keep modal visible with denied message
      // User can close browser tab/window to clear session
    });
    
    // Prevent closing modal by clicking outside
    ageVerification.addEventListener('click', function(e) {
      if (e.target === ageVerification || e.target.classList.contains('age-verification__overlay')) {
        e.stopPropagation();
      }
    });
    
    // Prevent ESC key from closing
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && ageVerification.style.display !== 'none') {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
